import type { CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';
import { buildEmptySlot } from './empty-slot';

export const BRAND_LOGOS_MAX = 9;

export interface BrandLogosOpts {
  pieceId?: string;
  position: { left: number; top: number; width: number; height: number };
  maxSlots?: number;
  rowGap?: number;
  colGap?: number;
  maxItemHeight?: number;
}

export function buildBrandLogos(opts: BrandLogosOpts): CanvasJSONLikeObject {
  const slots = opts.maxSlots ?? BRAND_LOGOS_MAX;
  const children = Array.from({ length: slots }, () => buildEmptySlot());

  return {
    pieceId: opts.pieceId ?? 'brand-logos',
    type: 'Group',
    version: '7.1.0',
    originX: 'center',
    originY: 'center',
    left: opts.position.left,
    top: opts.position.top,
    width: opts.position.width,
    height: opts.position.height,
    objectCaching: false,
    selectable: true,
    evented: true,
    layoutManager: { type: 'layoutManager', strategy: 'fixed' },
    groupCollection: {
      type: 'grid',
      width: opts.position.width,
      height: opts.position.height,
      rowGap: opts.rowGap ?? 16,
      colGap: opts.colGap ?? 24,
      maxItemHeight: opts.maxItemHeight ?? 120,
      urlPath: 'imageUrl'
    },
    objects: children
  };
}
